import { useEffect, useState } from 'react';
import { ifscValidator } from 'features/nach/utils/ifscValidator';

export function useIfscValidator(initialValue = '') {
  const [ifscCode, setIfscCode] = useState(initialValue);
  const [ifscError, setIfscError] = useState(false);
  const [branchName, setBranchName] = useState('');
  const [bankName, setBankName] = useState('');
  const [bankCode, setBankCode] = useState('');
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (!ifscCode || ifscCode.length < 11) {
      setIfscError(false);
      return;
    }

    const getTimeId = setTimeout(() => {
      ifscHandler(ifscCode);
    }, 1500);

    return () => clearTimeout(getTimeId);
  }, [ifscCode]);

  const ifscHandler = async (ifscCode: string) => {
    setLoading(true);
    const response = await ifscValidator({ ifsc: ifscCode });

    setLoading(false);

    if (response === null || response === 'not found') {
      setIfscError(true);
      setBranchName('');
      setBankName('');
      setBankCode('');
    } else {
      setIfscError(false);
      setBranchName(response.branchName || '');
      setBankName(response.bankName || '');
      setBankCode(response.bankCode || '');
    }
  };

  return {
    ifscError,
    setIfscCode,
    ifscCode,
    setIfscError,
    branchName,
    bankName,
    bankCode,
    isLoading,
  };
}
